import React from 'react';

import { token } from '@atlaskit/tokens';
import { useSession } from 'src/services/session';

import { getProdEnvironment } from 'src/lib/featureFlags';

import LogoutLink from 'src/views/components/links/LogoutLink';

const LoginMessage = () => {
  const { loggedIn, accountDomain, loading, environment: { apiBaseUrl, accountBaseUrl } } = useSession();
  if (loading || !loggedIn) return null;

  return (
    <span>
        Logged into <strong>{accountDomain}</strong>. { getProdEnvironment().apiBaseUrl !== apiBaseUrl
        && <span style={{ color: token('color.text.danger', 'red'), fontSize: token('font.size.075', '12px') }}>
            Using non-prod account: {accountBaseUrl}
        </span>}
      <LogoutLink> Logout</LogoutLink>
    </span>
  );
};

export default LoginMessage;
